import * as React from 'react';
import {ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import OnCloseWarning from '../Components/OnCloseWarning';
import Einstellungen from '../Components/Einstellungen';
import themes from '../Module/Themes';

import $ from 'jquery';
import _ from 'lodash';

import Speichersektion from '../Components/Speichersektion';

import FormularUnbestimmt from './FormularUnbestimmt';

import FormularMeldung from './FormularMeldung';
import FormularAbmeldung from './FormularAbmeldung';
import FormularHaltungsaenderung from './FormularHaltungsaenderung';
import FormularCites from './FormularCites';

import FullscreenMessage from "../Components/FullscreenMessage";

import WebServiceGet from '../Connectors/WebServiceGet';
import WebServicePost from '../Connectors/WebServicePost';


import webserviceParams from "../Entity/webserviceParams";
import {
  updateValue,
  removeEntityFromState,
  addValue,
  konfiguration,
} from '../Actions';

const styles = {
  sectionSpace: {
    marginBottom: "20px",
  },
  FormNumber: {
    display:"inline-block",
    border:"2px solid black",
    padding:"0 5px 0 5px",
  },
}

export default class Master extends React.Component {

  componentDidMount () {

    WebServiceGet(
      this.props.store.konfiguration.restPath + 'config.php',
      null,
      (data) => {
        this.props.dispatch(konfiguration("importierteKonfiguration", data))
      }
    )
  }

	state = {
		arrSpezies:[],
		openAntragsteller:false,
    ss_saved:false,
    ss_success:null,
    ss_message:'',
	}

  /**
   * Updates or adds Value tu state. Entry point (root) is "data".
   * @param {string} rtype Last part of path, usually "value", "touched" or "valid"
   * @param {string} root First part of path
   * @param {string} rtype Second part of path
   * @returns 
   */
  updateStandard = (rtype=null) => (root=null) => (subpath=null) => (value) => {
    let path = root
    if (subpath) {
      path += '.'+subpath
    }
    if (rtype) {
      path += '.'+rtype
    }

    this.props.dispatch(updateValue(path, value))
  }

  removeStandard = (part1=null) => (part2=null) => (part3=null) => {
    let path = []
    if (part1) {
      path.push(part1)
    }
    if (part2) {
      path.push(part2)
    }
    if (part3) {
      path.push(part3)
    }
    
    this.props.dispatch(removeEntityFromState(path))
  }

  errorList = (arr) => {
    let liste = []
    for (let i = 0; i<arr.length; i++) {
      liste.push(
        <p key={"error_sektion-"+i}>
          {arr[i]}
        </p>
      )
    }
    return liste
  }

  errorSektion = (validatorResult) => {

			if (!this.props.store.daten.debug) {
				return null
			}

      if (validatorResult.result) {
        return null
      }

      return (
        <div>
          <p>Erster Fehler</p>
          {this.errorList(validatorResult.errors)}
        </div>
      )
  }

  basicDispatch = {
    addValue: (path, value) => {
      this.props.dispatch(
        addValue(path, value)
      )
    },
    updateValue: (path, value) => {
      this.props.dispatch(
        updateValue(path,value)
      )
    },
  }


	ladeSpezies = (suchbegriff='') => {
    let params = webserviceParams(this.props.store.konfiguration.restPath + 'spezies.php', suchbegriff)
    params.callbackSuccess = (data) => {
                                this.setState({arrSpezies:data})
                              }
    params.dispatcher = this.basicDispatch
    //WebServiceGetter(params)
  }

  speichereDatenobjekt = (optionalSuccessFunction = ()=>{}) => {
    WebServicePost(
      this.props.store.konfiguration.restPath + 'saveDaten.php',
      this.cleanUp(this.props.store.daten),
      (data) => {
        this.saveResultHandler($.parseJSON(data))
        optionalSuccessFunction()
      },
      (data) => {
        this.saveResultHandler($.parseJSON(data))
      }
    )
  }

  cleanUp = (data) => {
    return this.deepOmit(data,"zoomIn");
  }

  deepOmit = (obj, keysToOmit) => {
    var keysToOmitIndex =  _.keyBy(Array.isArray(keysToOmit) ? keysToOmit : [keysToOmit] ); // create an index object of the keys that should be omitted
  
    function omitFromObject(obj) { // the inner function which will be called recursivley
      if (typeof(obj) == "function") {
        return;
      }
      return _.transform(obj, function(result, value, key) { // transform to a new object
        if (key in keysToOmitIndex) { // if the key is in the index skip it
          return;
        }
  
        result[key] = _.isObject(value) ? omitFromObject(value) : value; // if the key is an object run it through the inner function - omitFromObject
      })
    }
    
    return omitFromObject(obj); // return the inner function result
  }

  saveResultHandler = (data) => {
    this.setState({ss_saved:true})
    if ( data.success == true ) {
      this.setState({ss_success:true})
      this.setState({ss_message:null})
    } else {
      this.setState({ss_success:false})
      if ( data.errors ) {
        this.setState({ss_message:data.errors})
      } else {
        this.setState({ss_message:null})
      }
    }
  }

  speziesGesetzt = () => {
    if (!this.props.store.daten.spezies.wiss) {
      return false
    }
    return true
  }


  sektionAbsenden = (title="Antrag jetzt Absenden", disabled=false, optionalSuccessFunction = ()=>{}) => {
    return (
      <div style={{...styles.sectionSpace}}>
        <Speichersektion
          saveStatus={this.state.ss_saved}
          saveSuccess={this.state.ss_success}
          speichern={this.speichereDatenobjekt}
          saveMessage={this.state.ss_message}
          debug={this.props.store.daten.debug}
          title={title}
          disabled={disabled}
          optionalSuccessFunction={optionalSuccessFunction}
        />
      </div>
    )
  }


  render () {
    if (Object.keys(this.props.store.konfiguration.importierteKonfiguration) < 1) {
      return <Container><FullscreenMessage>Initialisiere Konfiguration</FullscreenMessage></Container>;
    }

    return (
      <ThemeProvider
          theme={themes[this.props.store.daten.meta.theme]}
      >
        <CssBaseline />
          <Container>

              <OnCloseWarning />

              <Einstellungen
                themes={themes}
                activeTheme={this.props.store.daten.meta.theme}
                updateTheme={this.basicDispatch.updateValue}
              />
              
              {this.props.store.daten.debug &&
                <span>DEBUG</span>
              }

              {this.props.store.daten.antragstyp == "FormularMeldung" &&
                <FormularMeldung
                  updateStandard={this.updateStandard}
                  removeStandard={this.removeStandard}
                  dispatch={this.props.dispatch}
                  data = {this.props.store.daten}
                  form = {this.props.store.formular}
                  konfiguration = {this.props.store.konfiguration}
                  ladeSpezies = {this.ladeSpezies}
                  ladePlz = {this.ladePlz}
                  absenden={this.sektionAbsenden}
                  zeigeVorbesitzer={true}
                  zeigeNachzucht={false}
                  titel={
                    <div>
                      <h1><span style={styles.FormNumber}>01</span> Meldung besonders geschützte Wirbeltiere</h1>
                    </div>
                  }
                />
              }

              {this.props.store.daten.antragstyp == "FormularNachzucht" &&
                <FormularMeldung 
                  updateStandard={this.updateStandard}
                  removeStandard={this.removeStandard}
                  dispatch={this.props.dispatch}
                  data = {this.props.store.daten}
                  form = {this.props.store.formular}
                  konfiguration = {this.props.store.konfiguration}
                  ladeSpezies = {this.ladeSpezies}
                  ladePlz = {this.ladePlz}
                  absenden={this.sektionAbsenden}
                  zeigeVorbesitzer={false}
                  zeigeNachzucht={true}
                  titel={
                    <div>
                      <h1><span style={styles.FormNumber}>06</span> Meldung über Nachzuchten besonders geschützter Wirbeltiere</h1>
                    </div>
                  }
                />
              }

              {this.props.store.daten.antragstyp == "FormularWeitergabe" &&
                <FormularAbmeldung
                  updateStandard={this.updateStandard}
                  dispatch={this.props.dispatch}
                  data = {this.props.store.daten}
                  form = {this.props.store.formular}
                  konfiguration = {this.props.store.konfiguration}
                  ladeSpezies = {this.ladeSpezies}
                  ladePlz = {this.ladePlz}
                  absenden={this.sektionAbsenden}
                  weitergabeAuswaehlen={true}
                  titel={
                    <div>
                      <h1><span style={styles.FormNumber}>02</span> Weitergabe besonders geschützte Wirbeltiere</h1>
                    </div>
                  }
                />
              }

              {this.props.store.daten.antragstyp == "FormularAbmeldung" &&
                <FormularAbmeldung
                  updateStandard={this.updateStandard}
                  dispatch={this.props.dispatch}
                  data = {this.props.store.daten}
                  form = {this.props.store.formular}
                  konfiguration = {this.props.store.konfiguration}
                  ladeSpezies = {this.ladeSpezies}
                  ladePlz = {this.ladePlz}
                  absenden={this.sektionAbsenden}
                  weitergabeAuswaehlen={false}
                  titel={
                    <div>
                      <h1><span style={styles.FormNumber}>04</span> Abmeldung besonders geschützte Wirbeltiere</h1>
                    </div>
                  }
                />
              }

              {this.props.store.daten.antragstyp == "FormularHaltungsaenderung" &&
                <FormularHaltungsaenderung 
                  dispatch={this.props.dispatch}
                  data = {this.props.store.daten}
                  form = {this.props.store.formular}
                  konfiguration = {this.props.store.konfiguration}
                  ladeSpezies = {this.ladeSpezies}
                  ladePlz = {this.ladePlz}
                  absenden={this.sektionAbsenden}
                  titel={
                    <div>
                      <h1><span style={styles.FormNumber}>03</span> Haltungsänderung für besonders geschützte Wirbeltiere Anzeigen</h1>
                    </div>
                  }
                />
              }

              {this.props.store.daten.antragstyp == "FormularCites" &&
                <FormularCites
                  updateStandard={this.updateStandard}
                  removeStandard={this.removeStandard}
                  dispatch={this.props.dispatch}
                  data = {this.props.store.daten}
                  form = {this.props.store.formular}
                  konfiguration = {this.props.store.konfiguration}
                  ladeSpezies = {this.ladeSpezies}
                  ladePlz = {this.ladePlz}
                  absenden={this.sektionAbsenden}
                  titel={
                    <div>
                      <h1><span style={styles.FormNumber}>05</span> EU-Bescheinigung <small>(ehemals CITES)</small></h1>
                    </div>
                  }
                />
              }

              {!this.props.store.daten.antragstyp &&
                <FormularUnbestimmt/>
              }

          </Container>

      </ThemeProvider>
    )
  }

}
